<!--
 * @Author: your name
 * @Date: 2021-07-08 18:19:46
 * @LastEditTime: 2021-09-08 14:50:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\flool1.vue
-->
<template>
  <div class="floor-wrapper">
      <div class="floor-list"  v-for="(item,index) in floorList" :key="index"  @mousemove="handleOver(index)">
           <div class="floor-box" :class="(activeIndex==index&&showBorder) ? 'content-border':''" > 
            <div class="floor-hidden" v-if="item.isHidden">
                <el-divider>楼层{{index+1}}</el-divider>
                <div class="open-btn" >
                    <el-button class="width80" @click.native.prevent="handleShow(index,item.isHidden)"  type="primary" icon="el-icon-arrow-righ">显示</el-button>
                </div>
            </div>
        <div   class="floor-content" v-else>
            <div class="floor-top flex-sb">
                <p class="floor-title">{{item.title?item.title:'标题'}}</p>
                <p class="floor-more">查看更多</p>
            </div>
            <div class="product-wrapper flex">
                <div class="hidden-btn" >
                    <el-button class="width80" @click.native.prevent="handleShow(index,item.isHidden)" type="danger" icon="el-icon-arrow-down">隐藏</el-button>
                </div>
                <div class="product-img">
                    <img :src="item.imgUrl" alt="">
                </div>
                <div class="product-content" v-if="item.productList.length>0">
                    <productListImg class="product-item"  v-for="(list,index) in item.productList" :itemData="list" :itemIndex="index" :splitNumber='4' :key="index"></productListImg>
                </div>
                <div class="product-content"  v-else>
                    <productListImg class="product-item"  v-for="(list,index) in defaultProductList" :itemData="list" :itemIndex="index" :splitNumber='4' :key="index"></productListImg>
                </div>
            </div>
        </div>
        </div>

      <transition name="el-fade-in">
        <div class="mantle-box-c" v-if="activeIndex===index && !item.isHidden"  @mouseleave="handleOver('')">
            <div class="mantle-box-content-c">
                <p>主推商品楼层{{index+1}}编辑</p>
                <div class="margin-b10">
                    <el-button  class="width200" @click="changeItem(index)"  type='primary'>编辑</el-button>
                </div>
                <div>
                    <el-button class="width200" @click="handleShow(index,item.isHidden)"  type="danger">隐藏</el-button>
                </div>
                
            </div>
        </div>
    </transition>
    </div>
        
  </div>
</template>

<script>
import productListImg from "./productListImg";
import {defaultData} from './data/defaultData'
export default {
props:{
    activeName: {
        type: String,
        default: ''
    },
    templateStatus: {
        type:[String,Number],
        default: ''
    },
    activeTabName: {
        type: String,
        default: ''
    },
    floorList: {
        type: Array,
        default: function(){
        return []
        }
    },
},
components: {
    productListImg
},
data(){
    return{
        isHidden:false,
        activeIndex:'',
        defaultProductList:JSON.parse(JSON.stringify(defaultData.productList)).splice(0,8)
    }
},
computed: {
    showBorder(){
        return  this.activeName=='floor2'?true:false
    }
},
methods:{
    changeItem(i){
        this.activeIndex=i;
        this.$parent.choosenComments('floor2');
        this.$parent.choosenFloor(i);
    },
    handleShow(i,val){
        this.floorList[i].isHidden=!val
        this.$parent.choosenComments('');
    },
    handleOver(i){
        if(this.templateStatus==2  || this.templateStatus==3 || this.templateStatus==7){
            return
        }else  if(this.templateStatus>=5 && this.activeTabName=='first'){
            return 
        }
        this.activeIndex=i
    }
}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.floor-list{
    margin-bottom:20px ;
    position: relative;
}
 
.floor-content{
    position: relative;
    .hidden-btn{
        display: none;
        position: absolute;
        top:0;
        right:0;
    }
}
.floor-content:hover{
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    .hidden-btn{
        display: block;
    }
}

.floor-hidden{
  width: 1200px;
 
  background: #F8F8F9;
  position: relative;
  margin-bottom: 40px;
  .open-btn{
       position: absolute;
        top:-16px;
        right:0;
  }
  p{width: 100%;
    height: 0;
    border-top: 1px solid #eee;
  }
}
.floor-top{
    height: 60px;
    line-height: 60px;
    width: 1200px;
    border-bottom:1px solid $main-col;
    .floor-title{
        font-weight: bold;
        font-size: 30px;
        border-bottom:3px solid $main-col;
        width: 200px;
        cursor: pointer;
    }
    .floor-more{
        font-size: 20px;
        color:$main-col;
        cursor: pointer;
    }
}
.product-wrapper{
    margin-top: 20px;
    .product-img{
         
        height: 816px;
        flex:0 0 232px;
        margin-right: 10px;
        img{
            width: 100%;
            height: 100%;
        }
    }
}
.product-content{
    display: flex;
    flex-wrap: wrap;
    
    .product-item{
        margin-bottom: 20px;
    }
}
 
.content-border:after{
    content: "";
    position: absolute;
    left: 0px;
    bottom:0;
    top:0;
    right:0;
    border:2px dashed red;  
}

.mantle-box-c{
            position: absolute;
            z-index: 1000;
            left:0;
            bottom:0;
            right:0;
            top:0;
            background-color: rgba(0, 0, 0, 0.3);
            display: flex;
            justify-content: center;
            flex-direction: column;
            .mantle-box-content-c{
                text-align: center;
                p{
                    color:#fff;
                    line-height: 32px;
                    font-weight: bold;
                }
            }
            
        }
</style>
